// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import ClaimValueBody from './claim-value-body';
import ClaimValueDetails from '@deere/cps-it.warranty-model-factory/lib/claim-value-details';
import {FormattedMessage} from 'react-intl';

const ClaimValue = props => {

    const body = (
        <ClaimValueBody
            allowedActions={props.allowedActions}
            claimNumber={props.claimNumber}
            claimStatus={props.claimStatus}
            showAmountsInLocalCurrency={props.showAmountsInLocalCurrency}
            values={props.claimValueDetails}
        />
    );

    const claimValueTitle = (
        <div className='claim-value-title'>
            <FormattedMessage id='CLAIM_VALUE_DETAILS'/>
        </div>
    );

    return (
        <Accordion
            accordionId='claim-value'
            body={body}
            title={claimValueTitle}
        />
    );

};

ClaimValue.displayName = 'ClaimValue';
ClaimValue.propTypes = {
    allowedActions: PropTypes.arrayOf(PropTypes.instanceOf(ClaimAction)).isRequired,
    claimNumber: PropTypes.string.isRequired,
    claimStatus: PropTypes.string.isRequired,
    claimValueDetails: PropTypes.instanceOf(ClaimValueDetails).isRequired,
    showAmountsInLocalCurrency: PropTypes.bool.isRequired
};

export default ClaimValue;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-value/index.js